<template>
  <wz-page name="index" :is-loading="isLoading">loading</wz-page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      isLoading: true
    }
  },
  computed: {
    ...mapGetters('account', ['myInfo', 'myUid', 'myNick', 'isLogined']),
    ...mapGetters('laxin', ['myUid', 'inDCService'])
  },
  methods: {
    ...mapActions('account', ['goLogin', 'goLogout']),
    ...mapActions('laxin', ['loadPriv']),
    async init() {
      this.isLoading = true
      await this.loadPriv()
      const { myUid, inDCService } = this
      if (myUid > 0) {
        if (inDCService) {
          this.$router.replace('/dc')
        } else {
          this.$router.replace(`/da?uid=${myUid}`)
        }
      } else {
        // alert(myUid)
        this.goLogin()
      }
      this.isLoading = false
    }
  },
  created() {
    this.init()
  }
}
</script>
